<template>
  <div class="box abc">
    <header-child ref="headerss" />
    <breadcrumb-child />
    <div class="container">
      <div class="aaa">
        <div class="title">
          <span class="mine"
            >Корзина（{{ carList.length == 0 ? "0" : cart.total_num }}）</span
          >
          <span class="commodity t">товар </span>
          <span class="price t">Цена</span
          ><span class="quantity t">Количество</span
          ><span class="subtotal t">Сумму</span
          ><span class="note t">Примечания</span
          ><img
            v-if="carList.length != 0"
            @click="emptyGoods = true"
            class="delete"
            :src="
              deleImg
                ? require('../../assets/images/me_icon_clear(1).png')
                : require('../../assets/images/me_icon_clear.png')
            "
            alt=""
            @mouseover="deleImg = true"
            @mouseleave="deleImg = false"
          />
        </div>
      </div>

      <img
        v-if="carList.length == 0"
        class="null-state"
        src="../../assets/images/kongzhuangtai@2x.png"
        alt=""
      />
      <div class="product-list">
        <div class="product" v-for="(item, index) in carList" :key="index">
          <span class="serial-number">{{ index + 1 }}</span>
          <div class="hezi">
            <img
              class="yincang"
              v-if="item.status == 0"
              src="../../assets/images/watermask_img_unshelve_e@3x.png"
              alt=""
            />
            <el-image
              :src="item.graffiti_img ? item.graffiti_img : item.thumb"
              class="img"
              @click="tuya(item, index)"
              lazy
            >
              <div slot="error" class="image-slot">
                <span>Ошибка загрузки</span>
              </div>
              <div
                slot="placeholder"
                class="image-slot"
                v-loading="loading"
                element-loading-background="rgba(0, 0, 0, 0.2)"
              >
                <span class="dot"></span>
              </div>
            </el-image>
          </div>
          <p class="product-name">
            {{ item.name }}
          </p>
          <span class="price"
            >{{ calculateThePrice(parseFloat(item.price)) }}p</span
          >
          <div class="enter">
            <input
              class="quantity"
              type="number"
              v-model="item.quantity"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
              @blur.capture="update(item)"
            />
            <span class="base"> x {{ item.packages }}</span>
          </div>

          <span class="subtotal"
            >{{
              calculateThePrice(
                parseFloat(item.price * item.quantity * item.packages)
              )
            }}p</span
          >
          <textarea
            class="note"
            @blur.capture="update(item)"
            placeholder="примечан"
            v-model="item.desc"
          ></textarea>

          <span class="delete" @click="deletes(item.item_id)"> Удалить </span>
        </div>
        <div
          v-if="carList.length != 0"
          class="buy"
          :style="
            carList.length != 0 ? '' : 'position: fixed;left:0;bottom: 0;'
          "
        >
          <div class="content">
            <!-- <span class="notes">备注：</span> -->
            <input class="note" v-model="buyNote" placeholder="Примечания" />
            <span :class="total > 30000 ? 'total_2' : 'total'"
              >Виды：{{ total_quantity }}</span
            >
            <span class="totals" v-if="total < 30000">Итого：</span>
            <span class="money" v-if="total < 30000"
              >{{ calculateThePrice(total) }}p</span
            >
            <div class="discount" v-else>
              <p><span>Сумму ：</span> {{ calculateThePrice(total) }}p</p>
              <p class="margin" v-if="total < 80000">
                <span>-3%：</span>{{ calculateThePrice(total * 0.03) }}p
              </p>
              <p class="margin" v-else-if="total < 150000">
                <span>-6%：</span>{{ calculateThePrice(total * 0.06) }}p
              </p>
              <p class="margin" v-else-if="total > 15000">
                <span>-8%：</span>{{ calculateThePrice(total * 0.08) }}p
              </p>
              <p class="heji" v-if="total < 80000">
                <span>Итого：</span>{{ calculateThePrice(total * 0.97) }}p
              </p>
              <p class="heji" v-else-if="total < 150000">
                <span>Итого：</span>{{ calculateThePrice(total * 0.94) }}p
              </p>
              <p class="heji" v-else-if="total > 15000">
                <span>Итого：</span>{{ calculateThePrice(total * 0.92) }}p
              </p>
            </div>
            <span class="buys" @click="addOrder">Купить</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="deletePopUpWindow"
      width="504px"
      :before-close="handleClose"
      custom-class="deletePopUpWindows"
      class="deletePopUpWindow"
      :closeOnClickModal="false"
    >
      <img class="titleImg" src="../../assets/images/img_logo.png" alt="" />
      <el-divider></el-divider>
      <p class="prompt">
        <img src="../../assets/images/pop_icon_tip.png" alt="" />
        Удалить товар?
      </p>
      <div class="button">
        <span class="cancel" @click="deletePopUpWindow = false">Нет</span>
        <span class="determine" @click="deletesDetermine">Да</span>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="emptyGoods"
      width="504px"
      :before-close="handleClose"
      custom-class="deletePopUpWindows"
      class="deletePopUpWindow"
      :closeOnClickModal="false"
    >
      <img class="titleImg" src="../../assets/images/img_logo.png" alt="" />
      <el-divider></el-divider>
      <p class="gantan"><span class="error">i</span></p>
      <p class="prompt">Удалить?</p>
      <div class="button">
        <span class="cancel" @click="emptyGoods = false">Нет</span>
        <span class="determine" @click="emptyCart">Да</span>
      </div>
    </el-dialog>
    <el-dialog
      v-if="graffiti"
      :visible.sync="graffiti"
      width="1072px"
      :before-close="handleClose"
      :closeOnClickModal="false"
    >
      <div class="canvas-container">
        <div
          v-loading="load"
          class="aoligei"
          ref="aoligei"
          element-loading-background="rgba(0, 0, 0, 0.3)"
        ></div>
      </div>
      <div class="information">
        <span class="introduction">{{ graffitiGoods.intro }}</span
        ><br />
        <div class="note">
          <img src="../../assets/images/me_iocn_bianji.png" alt="" />
          <textarea
            v-model="graffitiGoods.desc"
            placeholder="Примечания"
          ></textarea>
        </div>

        <p>
          <span class="unit-price" style="font-weight: bold; color: #ff3b3b"
            >{{ calculateThePrice(parseFloat(graffitiGoods.price)) }}p </span
          >x
          <input type="number" v-model="graffitiGoods.quantity" />
          x {{ graffitiGoods.packages }} =
          {{
            calculateThePrice(
              graffitiGoods.price *
                graffitiGoods.quantity *
                graffitiGoods.packages
            )
          }}
          p
        </p>
        <div class="favorable">
          <p>
            -3%：<span class="s1"
              >{{
                calculateThePrice(parseFloat(graffitiGoods.price * 0.97))
              }}p</span
            >
          </p>
          <p>
            -6%：<span class="s1"
              >{{
                calculateThePrice(parseFloat(graffitiGoods.price * 0.94))
              }}p</span
            >
          </p>
          <p>
            -8%：<span class="s1"
              >{{
                calculateThePrice(parseFloat(graffitiGoods.price * 0.92))
              }}p</span
            >
          </p>
        </div>
        <el-button class="join" type="warning" @click="addShowToShoppingCart()"
          >Добавить</el-button
        >
      </div>
      <graffiti
        ref="graffiti"
        :imgPath="graffitiGoods"
        :subscriptIndex="0"
        :graffiti="load"
      />
    </el-dialog>
    <div class="mask" v-if="downShow">
      <div class="popup">
        <div class="title">3аказ уже представлен</div>
        <div class="item-title">Недостающие товары были удалены</div>
        <div class="item" v-for="(item, index) in delList" :key="index">
          {{ item }}
        </div>
        <div class="button" @click="getConfirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import headerChild from "../../components/Header";
import breadcrumbChild from "../../components/Breadcrumb";
import { num, Toast } from "../../api/method";
import Graffiti from "../../components/Graffiti";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { headerChild, breadcrumbChild, Graffiti },
  data() {
    //数据
    return {
      deleImg: false, //清空图片状态
      loading: true,
      deletePopUpWindow: false, //删除商品弹窗
      emptyGoods: false, //清空商品弹窗
      carList: [], //购物车列表
      cart: {}, //我的购物车
      buyNote: "", //购买备注
      order_sn: "", //订单号
      total: null,
      total_quantity: null,
      graffiti: false,
      commodity: 0,
      load: true,
      num: null,
      downShow: false, //删除下架商品的弹窗
      del_ids: "", //删除的id
      delList: [], //删除的列表
    };
  },
  //计算属性
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getCatList();
  },
  //方法集合
  methods: {
    handleClose(done) {
      done();
      let ele = document.getElementById("canvas");
      if (ele) {
        ele.remove();
      }
    },
    loads() {
      this.load = false;
      // console.log(66666666);
    },
    tuya(item, index) {
      this.graffiti = true;
      this.graffitiGoods = item;
      this.commodity = index;
      this.$nextTick(() => {
        this.$refs.graffiti.initialization();
      });
    },
    //购买
    addOrder() {
      let arr = [];
      let arrobj = [];
      this.carList.forEach((item) => {
        if (item.status == 0) {
          arr.push(item.id);
          arrobj.push(item.name);
        }
      });
      this.del_ids = arr.toString();
      this.delList = arrobj;
      if (this.del_ids.length == 0) {
        let data = {
          token: localStorage.getItem("token"),
          desc: this.buyNote,
          o_status: 2,
          order_sn: this.order_sn,
          uid: this.carList[0].uid,
        };
        this.api.addOrder(data).then((res) => {
          this.Toast(res);
          if (res.status == 1) {
            setTimeout(() => {
              this.$router.push({
                path: "/orderIndex",
              });
            }, 200);
            this.getCatList();
          }
        });
      } else {
        this.getDel();
      }
    },
    // 弹窗删除
    getDel() {
      console.log("删除");
      let data = {
        token: localStorage.getItem("token"),
        item_id: this.del_ids,
      };
      this.api.remove(data).then((res) => {
        this.downShow = true;
      });
    },
    //弹窗确认
    getConfirm() {
      this.downShow = false;
      this.getCatList();
    },
    operationalData(val) {
      this.carList[this.commodity].graffiti_img = val;
      this.$forceUpdate();
      // console.log(val);
    },
    //购物车数据更新
    update(item) {
      console.log(item);
      // this.getCatList();
      // console.log(11111);
      let data = {
        token: localStorage.getItem("token"),
        item_id: item.item_id,
        desc: item.desc,
        quantity: item.quantity,
      };
      this.api.update(data).then((res) => {
        // console.log(res);
        // Toast(res);
        if (res.status == 1) {
          this.total = 0;
          // this.total_quantity = 0;
          this.carList.forEach((item, index) => {
            this.total =
              parseInt(this.total * 1) +
              parseInt(item.packages * item.price * item.quantity);
            // this.total_quantity = parseInt(this.total_quantity) + parseInt(item.quantity);
          });
        }
      });
    },
    //删除商品-弹窗-确定按钮回调
    deletesDetermine() {
      this.api
        .remove({
          token: localStorage.getItem("token"),
          item_id: this.commodityId,
        })
        .then((res) => {
          this.deletePopUpWindow = false;
          this.Toast(res);
          if (res.status == 1) {
            this.getCatList();
            setTimeout(() => {
              this.$nextTick(() => {
                this.$refs.headerss.doCount();
              });
            }, 100);
          }
          // console.log(res);
        });
    },
    //删除商品-弹窗
    deletes(id) {
      this.deletePopUpWindow = true;
      this.commodityId = id;
    },
    //关闭弹窗
    handleClose(done) {
      done();
      // clearTimeout(this.time);
      this.load = true;
      // this.doodle = new Date().getTime();
      // this.imgUrl = null;
      let ele = document.getElementById("canvas");
      if (ele) {
        ele.remove();
      }
    },
    //获取购物车商品列表
    getCatList() {
      this.total = 0;
      this.api
        .getCatList({
          token: localStorage.getItem("token"),
          timezone: -(new Date().getTimezoneOffset() / 60),
        })
        .then((res) => {
          console.log(res);
          this.carList = res.data.list;
          // this.carList.forEach((item) => {
          //   // item.status = false;
          // });
          this.$set(this.carList, res.data.list);
          this.carList.forEach((item) => {
            this.total += item.packages * item.price * item.quantity;
            item.id = item.item_id;
            item.graffiti_img = item.graffiti_img
              ? item.graffiti_img +
                "?imageMogr2/format/heif?imageMogr2/thumbnail/636x"
              : item.thumb +
                "?imageMogr2/format/heif?imageMogr2/thumbnail/636x";
          });
          this.total_quantity = res.data.cart_count.total_quantity;
          this.order_sn = res.data.order_sn;
          this.cart = res.data.cart_count;
          if (this.del_ids.length != 0) {
            this.addOrder();
          }
        });
    },
    //清空购物车
    emptyCart() {
      this.api
        .emptyCart({ token: localStorage.getItem("token") })
        .then((res) => {
          this.emptyGoods = false;
          if (res.status == 1) {
            this.$refs.headerss.doCount();
            this.carList = [];
          }
          this.Toast(res);
        });
    },
    /**
     * 计算千分位
     */
    calculateThePrice(str) {
      // console.log(str.toString());
      return num(str);
    },
    addShowToShoppingCart() {
      this.graffiti = false;
      this.load = true;
      // console.log(this.graffitiGoods);
      if (
        this.graffitiGoods.quantity == null ||
        this.graffitiGoods.quantity == 0
      ) {
        this.api
          .remove({
            token: localStorage.getItem("token"),
            item_id: this.graffitiGoods.item_id,
          })
          .then((res) => {
            this.Toast(res);
            if (res.status == 1) {
              this.$refs.headerss.doCount();
              this.getCatList();
            }
          });
        return;
      }
      console.log(this.graffitiGoods);

      let data = {
        token: localStorage.getItem("token"),
        item_id: this.graffitiGoods.item_id,
        quantity: this.graffitiGoods.quantity,
        desc: this.graffitiGoods.desc,
        type: "",
      };
      this.api.add(data).then((res) => {
        // console.log(res);
        this.Toast(res);
        if (res.status == 1) {
          this.$refs.headerss.doCount();
          this.graffitiGoods.added = true;
          this.graffiti = false;
          // this.update(this.graffitiGoods);
          this.$forceUpdate();
        }
      });
      this.update(this.graffitiGoods);
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
.hezi {
  display: inline-block;
  vertical-align: top;
  position: relative;
  .yincang {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 12px;
    margin: auto;
    left: 48px;
    width: 76px;
    height: 66px;
    // object-fit: cover;
    z-index: 2;
  }
}
/deep/.el-image__inner {
  vertical-align: top;
  object-fit: cover !important;
}
/deep/.el-dialog {
  margin-top: 5vh !important;
}
/deep/.aoligei {
  height: 636px;
}
/deep/.path {
  stroke: #edc18a;
}
/deep/.deletePopUpWindows .el-dialog__header {
  position: absolute;
}
/deep/.el-dialog__body {
  padding-top: 0;
  // padding-bottom: 92px;
  position: relative;
  .canvas-container {
    width: 636px;
    height: 636px;
    opacity: 1;
    display: inline-block;
    position: relative;
    // text-align: center;
    .position {
      text-align: center;
      display: inline-block;
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
      bottom: 12px;
      width: 68px;
      height: 26px;
      background: #ff3939;
      opacity: 0.74;
      border-radius: 18px;
      z-index: 3;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 26px;
      color: #ffffff;
      transition: all 0.2s;
    }
  }
  .information {
    display: inline-block;
    width: 365px;
    height: 200px;
    vertical-align: top;
    padding-top: 20px;
    padding-left: 18px;
    .introduction {
      height: 86px;
      display: inline-block;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      opacity: 1;
    }
    p {
      height: 22px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      opacity: 1;
      input {
        padding: 0 12px;
        width: 69px;
        height: 22px;
        background: #f5f5f5;
        opacity: 1;
        border: none;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 22px;
        color: #333333;
        opacity: 1;
      }
    }
    .join {
      margin-top: 55px;
      margin-left: 82px;
      width: 232px;
      height: 50px;
      background: #edc18a;
      opacity: 1;
      border-radius: 6px;
      border: none;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 22px;
      color: #ffffff;
      opacity: 1;
    }
    .favorable {
      margin-top: 15px;
      p {
        height: 19px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #333333;
        opacity: 1;
        margin-bottom: 6px;
        span {
          font-weight: 400;
          color: #ff3939;
        }
      }
    }
    .note {
      background: #f8f8f8;
      padding: 7px;
      width: 365px;
      margin-bottom: 53px;
      img {
        width: 14px;
        height: 14px;
        vertical-align: top;
        margin-top: 2px;
        margin-right: 3px;
      }
      textarea {
        width: 330px;
        height: 163px;
        background: #f8f8f8;
        opacity: 1;
        border: none;
        resize: none;
        border: none;
        resize: none;
        /* 去除选中后的边框 */
        outline: none;
        // padding: 7px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #333333;
      }
    }
  }
}
/deep/.deletePopUpWindows {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
    padding-bottom: 16px;
  }
}

.deletePopUpWindow {
  .titleImg {
    width: 150px;
    position: relative;
    top: 10px;
    left: 20px;
  }
  .gantan {
    text-align: center;
    .error {
      display: inline-block;
      margin-top: -2px;
      vertical-align: middle;
      width: 60px;
      height: 60px;
      background: #ff3939;
      font-size: 34px;
      font-weight: bold;
      opacity: 1;
      line-height: 60px;
      text-align: center;
      border-radius: 50%;
      transform: rotate(180deg);
      color: #fff;
    }
  }
  .prompt {
    text-align: center;
    font-size: 20px;
    width: 330px;
    left: 0;
    right: 0;
    margin: 0 auto;
    font-family: Microsoft YaHei;
    font-weight: 400;
    vertical-align: middle;
    color: #333333;
    margin-bottom: 40px;
    opacity: 1;
    img {
      width: 24px;
      vertical-align: middle;
      height: 24px;
      margin-top: -2px;
    }
  }
  .button {
    text-align: center;
    .determine {
      display: inline-block;
      width: 96px !important;
      height: 40px;
      background: #edc18a;
      opacity: 1;
      border-radius: 4px;
      width: 32px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 40px;
      color: #ffffff;
      opacity: 1;
      text-align: center;

      cursor: pointer;
    }
    .cancel {
      margin-right: 24px;
      display: inline-block;
      width: 96px !important;
      height: 40px;
      background: #ffffff;
      border: 1px solid #e6e6e6;
      opacity: 1;
      border-radius: 4px;
      width: 32px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 40px;
      cursor: pointer;
      color: #666666;
      opacity: 1;
      text-align: center;
    }
  }
}

.buy {
  // position: relative;
  width: 100%;
  height: 80px;
  margin-top: 20px;
  .content {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 1200px;
    // position: relative;
    margin: 0 auto;
    height: 80px;
    background: #f6f6f6;
    border: 1px solid #e6e6e6;
    opacity: 1;
    // box-shadow: 1px -1px 5px #888888;
    // padding: 12px 0 12px 20px;
    padding-left: 20px;
    .notes {
      height: 19px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      vertical-align: middle;
      color: #333333;
      opacity: 1;
    }

    .note {
      margin-top: 20px;
      resize: none;
      width: 400px;
      vertical-align: top;
      height: 48px;
      background: #ffffff;
      border: 1px solid #e6e6e6;
      opacity: 1;
      padding: 5px;
      margin-right: 306px;
    }
    textarea {
      border: none;
      resize: none;
      /* 去除选中后的边框 */
      outline: none;
    }
    textarea:focus {
      outline: none !important;
      border: 1px solid edc18a;
      border-color: #edc18a;
    }
    .total_2 {
      height: 21px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      opacity: 1;
      margin-right: 73px;
      vertical-align: top;
      display: inline-block;
      margin-top: 50px;
    }
    .total {
      height: 21px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      opacity: 1;
      margin-right: 73px;
      vertical-align: top;
      display: inline-block;
      margin-top: 28.5px;
    }
    .totals {
      width: 48px;
      height: 21px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 20px;
      color: #333333;
      vertical-align: top;
      display: inline-block;
      margin-top: 28.5px;
      margin-right: 8px;
      opacity: 1;
    }
    .money {
      height: 21px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 20px;
      display: inline-block;
      margin-top: 28.5px;
      color: #ff3939;
      vertical-align: top;
      opacity: 1;
    }
    .discount {
      display: inline-block;
      height: 100%;
      width: 200px;
      padding: 8px 0;
      p {
        // text-align: center;
        height: 16px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
        color: #666666;
        opacity: 1;
        span {
          display: inline-block;
          text-align: right;
          width: 60px;
          height: 16px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 20px;
          color: #999999;
          opacity: 1;
        }
      }
      .margin {
        margin: 5px 0;
      }
      .heji {
        width: 400px;
        margin-left: -10px;
        height: 21px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 20px;
        color: #ff3939;
        opacity: 1;
        span {
          height: 21px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 20px;
          color: #333333;
          opacity: 1;
        }
      }
    }
    .buys {
      display: inline-block;
      position: absolute;
      cursor: pointer;
      right: 0;
      top: -1px;
      width: 144px;
      height: 80px;
      background: #edc18a;
      opacity: 1;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 74px;
      text-align: center;
      color: #ffffff;
      opacity: 1;
    }
  }
}
.container {
  // overflow: hidden;
  // position: absolute;
  // left: 0;
  // right: 0;
  // margin: 0 auto;
  padding-bottom: 102px;
  .null-state {
    position: absolute;
    width: 200px;
    height: 200px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    opacity: 0.4;
    margin-top: 250px;
  }
  .aaa {
    height: 64px;
    width: 100%;
    // margin: 20px 0 17px 0;
  }
  .title {
    position: fixed;
    // height: 24px;
    width: 100%;
    padding: 20px 0 17px 0;
    background: #ffffff;
    z-index: 99;
    .mine {
      width: 170px;
      height: 24px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 20px;
      color: #333333;
      opacity: 1;
      position: absolute;
    }
    .commodity {
      margin-left: 211px;
      margin-right: 195px;
    }
    .price {
      margin-right: 125px;
    }
    .quantity {
      margin-right: 111px;
    }
    .subtotal {
      margin-right: 120px;
    }
    .note {
      margin-right: 108px;
    }
    .t {
      width: 28px;
      height: 19px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: #666666;
      opacity: 1;
    }
    .delete {
      width: 18px;
      height: 18px;
      line-height: 24px;
      position: relative;
      top: 4px;
    }
  }
  .product-list {
    width: 100%;
    background: #ffffff;
    border-top: 1px solid #e6e6e6;
    opacity: 1;

    .product:last-child {
      border: none;
    }
    .product {
      width: 100%;
      height: 120px;
      padding: 12px 0px 12px 0;
      border: 1px solid #e6e6e6;
      border-top: none;
      position: relative;

      .serial-number {
        display: inline-block;
        text-align: center;
        width: 48px;
        height: 19px;
        position: absolute;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 96px;
        color: #333333;
        opacity: 1;
      }
      .img {
        margin-left: 48px;
        margin-right: 12px;
        width: 96px;
        height: 96px;
        // background: #f6eeea;
        opacity: 1;
        border-radius: 4px;
        vertical-align: top;
        .image-slot {
          height: 100%;
          width: 100%;
          span {
            border-radius: 4px;
            display: inline-block;
            width: 100%;
            height: 100%;
            text-align: center;
            padding-top: 25px;
            color: #e5e5e5;
            // border: 1px solid #e5e5e5;
          }
        }
      }
      .product-name {
        display: inline-block;
        width: 280px;
        height: 100%;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        opacity: 1;
        line-height: 96px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: top;
      }
      .price {
        display: inline-block;
        text-align: center;
        width: 67px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 96px;
        vertical-align: middle;
        color: #ff3939;
        opacity: 1;
        margin-right: 100px;
      }
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        appearance: none;
        margin: 0;
      }
      input {
        -moz-appearance: textfield;
      }
      .enter {
        width: 190px;
        display: inline-block;
        .quantity {
          display: inline-block;
          width: 48px;
          height: 24px;
          background: #f8f8f8;
          opacity: 1;
          text-align: center;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 24px;
          color: #333333;
          opacity: 1;
          border: none;
          appearance: none;
        }
        .base {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 19px;
          color: #333333;
          opacity: 1;
        }
      }

      .subtotal {
        display: inline-block;
        width: 120px;
        height: 19px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #333333;
        opacity: 1;
      }
      .note {
        resize: none;
        width: 180px;
        vertical-align: middle;
        height: 48px;
        background: #ffffff;
        border: 1px solid #e6e6e6;
        opacity: 1;
        padding: 5px;
        margin-right: 40px;
        overflow-x: scroll;
        //滚动条消失
        &::-webkit-scrollbar {
          display: none;
        }
      }
      textarea:focus {
        outline: none !important;
        border: 1px solid edc18a;
        border-color: #edc18a;
      }
      .delete {
        display: inline-block;
        height: 19px;
        font-size: 14px;
        cursor: pointer;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #e9ad61;
        opacity: 1;
      }
    }
  }
}
.mask {
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
}
.popup {
  background: #414141;
  width: 400px;
  position: fixed;
  top: 30%;
  right: 0;
  left: 0;
  opacity: 0.9;
  color: #fff;
  border-radius: 6px;
  margin: 0 auto;
  text-align: center;
  z-index: 100;
  margin: auto;

  .title {
    line-height: 70px;
    height: 70px;
    border-bottom: 1px solid #f8f8f8;
    font-size: 16px;
    font-weight: bold;
  }
  .item-title {
    text-align: left;
    padding-left: 70px;
    margin: 24px 0 14px;
  }
  .item {
    text-align: left;
    padding-left: 70px;
  }
  .button {
    line-height: 60px;
    height: 60px;
    border-top: 1px solid #f8f8f8;
    font-size: 16px;
    font-weight: bold;
    margin-top: 21px;
  }
  .button:hover {
    cursor: pointer;
  }
}
</style>
